<template>
  <div class="notice-manage-container">
    <!-- 查询条件 -->
    <el-card class="search-wrapper">
      <div slot="header" class="flex justify-between">
        <span>党组织信息</span>
      </div>
      <div>
        <el-form
          ref="formRef"
          :model="formData"
          label-width="120px"
          :rules="rules"
          size="default"
        >
          <div style="display: flex">
            <div style="width: 500px">
              <el-form-item label="党组织全称" prop="name">
                <div v-if="!isEditing" class="text">{{ formData.name }}</div>
                <el-input
                  v-else
                  v-model="formData.name"
                  placeholder="请输入党组织全称"
                  clearable
                />
              </el-form-item>

              <el-form-item label="党组织简称" prop="xmbh">
                <div v-if="!isEditing" class="text">{{ formData.xmbh }}</div>
                <el-input
                  v-else
                  v-model="formData.xmbh"
                  placeholder="请输入党组织简称"
                  clearable
                />
              </el-form-item>
              <el-form-item label="上级党组织" prop="deviceNo">
                <div v-if="!isEditing" class="text">
                  {{ formData.deviceNo }}
                </div>
                <el-input
                  v-else
                  v-model="formData.deviceNo"
                  placeholder="请输入上级党组织"
                  clearable
                />
              </el-form-item>
              <el-form-item label="党组织类型" prop="address">
                <div v-if="!isEditing" class="text">{{ formData.address }}</div>
                <el-input
                  v-else
                  v-model="formData.address"
                  placeholder="请输入党组织类型"
                  clearable
                />
              </el-form-item>

              <el-form-item label="党组织编码" prop="installPosition">
                <div v-if="!isEditing" class="text">
                  {{ formData.installPosition }}
                </div>
                <el-input
                  v-else
                  v-model="formData.installPosition"
                  placeholder="请输入党组织编码"
                  clearable
                />
              </el-form-item>

              <el-form-item label="成立日期" prop="contact">
                <div v-if="!isEditing" class="text">{{ formData.contact }}</div>
                <el-input
                  v-else
                  v-model="formData.contact"
                  placeholder="请输入联系人"
                  clearable
                />
              </el-form-item>

              <el-form-item label="党员总数" prop="phone">
                <div v-if="!isEditing" class="text">{{ formData.phone }}</div>
                <el-input
                  v-else
                  v-model="formData.phone"
                  placeholder="请输入党员总数"
                  clearable
                />
              </el-form-item>
              <el-form-item label="正式党员总数" prop="phone">
                <div v-if="!isEditing" class="text">{{ formData.phone }}</div>
                <el-input
                  v-else
                  v-model="formData.phone"
                  placeholder="请输入正式党员总数"
                  clearable
                />
              </el-form-item>
              <el-form-item label="预备党员总数" prop="phone">
                <div v-if="!isEditing" class="text">{{ formData.phone }}</div>
                <el-input
                  v-else
                  v-model="formData.phone"
                  placeholder="请输入预备党员总数"
                  clearable
                />
              </el-form-item>
            </div>
            <div style="width: 500px">
              <el-form-item label="书记信息" prop="name">
                <div v-if="!isEditing" class="text">{{ formData.name }}</div>
                <el-input
                  v-else
                  v-model="formData.name"
                  placeholder="请输入书记信息"
                  clearable
                />
              </el-form-item>

              <el-form-item label="副书记信息" prop="xmbh">
                <div v-if="!isEditing" class="text">{{ formData.xmbh }}</div>
                <el-input
                  v-else
                  v-model="formData.xmbh"
                  placeholder="请输入副书记信息"
                  clearable
                />
              </el-form-item>
              <el-form-item label="委员信息" prop="deviceNo">
                <div v-if="!isEditing" class="text">
                  {{ formData.deviceNo }}
                </div>
                <el-input
                  v-else
                  v-model="formData.deviceNo"
                  placeholder="请输入上级党组织"
                  clearable
                />
              </el-form-item>
              <el-form-item label="联络员信息" prop="address">
                <div v-if="!isEditing" class="text">{{ formData.address }}</div>
                <el-input
                  v-else
                  v-model="formData.address"
                  placeholder="请输入联络员信息"
                  clearable
                />
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="button-group">
          <el-button
            class="button"
            type="primary"
            @click="saveData"
            v-if="isEditing"
            >保存</el-button
          >
          <el-button class="button" @click="cancelEdit" v-if="isEditing"
            >取消</el-button
          >
          <el-button class="button" @click="toggleEdit(true)" v-else
            >编辑</el-button
          >
        </div>
      </div>
    </el-card>

    <!-- 公告列表 -->

    <!-- 删除确认对话框 -->
    <delete-notice ref="deleteNotice" @success="handleSuccess" />
    <edit-declaration ref="editDeclaration" @success="handleSuccess" />
    <add-declaration ref="addDeclaration" @success="handleSuccess" />
  </div>
</template>

<script>
import { listQuarter } from "@/api/oa/noticeManageApi";
import DeleteNotice from "@/components/oa/deleteMember";
import { getCommunityId } from "@/api/community/communityApi";
import AddDeclaration from "@/components/oa/AddPet";
import EditDeclaration from "@/components/oa/editMember";

export default {
  name: "propertyAccountList",
  components: {
    DeleteNotice,
    AddDeclaration,
    EditDeclaration,
  },
  data() {
    return {
      isEditing: false,
      loading: false,
      searchForm: {
        title: "",
        noticeTypeCd: "",
        state: "",
        startTime: "",
        endTime: "",
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      communityId: "",
      rules: {
        name: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
          { max: 100, message: "项目名称不能超过100个字符", trigger: "blur" },
        ],
        deviceNo: [
          { required: true, message: "请输入设备编号", trigger: "blur" },
          { max: 100, message: "设备编号不能超过100个字符", trigger: "blur" },
        ],
        xmbh: [
          { required: true, message: "请输入项目编号", trigger: "blur" },
          { max: 100, message: "项目编号不能超过100个字符", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入项目位置", trigger: "blur" },
          { max: 100, message: "项目位置不能超过100个字符", trigger: "blur" },
        ],
        installPosition: [
          { required: true, message: "请输入设备安装位置", trigger: "blur" },
          {
            max: 100,
            message: "设备安装位置不能超过100个字符",
            trigger: "blur",
          },
        ],
        contact: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          { max: 100, message: "联系人不能超过100个字符", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { max: 100, message: "手机号不能超过100个字符", trigger: "blur" },
        ],
      },
      formData: {
        name: "",
        deviceNo: "",
        xmbh: "",
        address: "",
        installPosition: "",
        contact: "",
        phone: "",
        remark: "",
      },
    };
  },
  created() {
    this.communityId = getCommunityId();
    this.getList();
  },
  methods: {
    async getList() {
      try {
        this.loading = true;
        const params = {
          page: this.pagination.current,
          row: this.pagination.size,
          ...this.searchForm,
          communityId: this.communityId,
        };
        const { notices, total } = await listQuarter(params);
        this.tableData = notices;
        this.pagination.total = total;
      } catch (error) {
        this.$message.error(this.$t("quarterFinance.fetchError"));
      } finally {
        this.loading = false;
      }
    },

    handleReset() {
      this.searchForm = {
        title: "",
        noticeTypeCd: "",
        state: "",
        startTime: "",
        endTime: "",
      };
      this.getList();
    },
    handleAdd() {
      this.$refs.addDeclaration.open();
    },
    handleEdit(row) {
      this.$refs.editDeclaration.open(row);
    },
    handleDelete(row) {
      this.$refs.deleteNotice.open(row);
    },
    handleSuccess() {
      this.getList();
    },
    handleSizeChange(val) {
      this.pagination.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },
    toggleEdit(isEditing) {
      this.isEditing = isEditing;
    },
    cancelEdit() {
      this.isEditing = false;
    },
    saveData() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          // 表单验证通过，提交数据
          console.log("提交数据：", this.formData);
          this.isEditing = false;
        } else {
          console.log("表单验证失败");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.notice-manage-container {
  padding: 20px;

  .search-wrapper {
    margin-bottom: 20px;

    .el-row {
      margin-bottom: 20px;
    }
  }

  .list-wrapper {
    .el-pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
